<template>
  <!-- 页面在微信中运行时，不识别 accept=".png,.jpeg,.jpg,.gif,.bmp"，因此使用通配符 -->
  <div class="image-uploader">
    <input
      ref="fileInput"
      type="file"
      name="file"
      accept="image/*"
      multiple
      @change="onHandleFiles"
    />
  </div>
</template>

<script>
import { SDKUtils } from '@/imsdk/index';

const MAX_NUM = 5;

export default {
  data() {
    return {
    };
  },
  methods: {
    // 对外暴露的click接口，用来触发上传过程
    // 后续如果要处理类似 权限弹框 功能可以在此处实现
    click() {
      this.$refs.fileInput.click();
    },

    onHandleFiles(event) {
      const { files } = event.target;
      if (files.length > MAX_NUM) {
        this.$emit('upload', {
          code: -1,
          id: '',
          message: `一次最多支持选择${MAX_NUM}张图片`,
        });
        return;
      }

      Array.from(files).forEach(async (file) => {
        this.uploadFile(file);
      });

      // eslint-disable-next-line no-param-reassign
      event.target.value = '';
    },

    async uploadFile(file, reSendInfo = null) {
      console.log('[uploadFile]', file, reSendInfo);
      const rs = await SDKUtils.uploadImage(file, reSendInfo, {
        onPreview: (info) => {
          this.$emit('preview', info);
        },
      });
      this.$emit('upload', rs);
    },
  },
};
</script>

<style lang="less" scoped>
.image-uploader input {
  position: absolute;
  visibility: hidden;
  z-index: -999;
  width: 0px;
  height: 0px;
  top: 0px;
  left: 0px;
}
</style>
